import React, { Component } from 'react';
import Modal from './Modal';
import Button from '../button/Button';
import Icon from '../icon/Icon';

export default class BaseModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      visible,
      children,
      title,
      onCloseModal,
      onConfirm,
      showCloseIcon = true,
      showFooter = true,
      className
    } = this.props;

    return (
      <Modal
        visible={visible}
        bodyStyle={{ padding: 0, width: '300px', maxHeight: '100%', borderRadius: 4, overflow: 'hidden' }}
      >
        <div className={['lf-modal-content-wrap', className].join(' ')}>
          <div className="lf-modal-header">
            <span className="lf-modal-title">{title}</span>
            {
              showCloseIcon
                ? <Icon className="lf-modal-header-close-icon" icon="cuo" style={{ color: '#000' }} onClick={onCloseModal} />
                : ''
            }
          </div>
          <div className="lf-modal-body" style={{ maxHeight: document.body.clientHeight * 0.7, overflowY: 'auto' }}>
            {children}
          </div>
          {
            showFooter ? (
              <div className="lf-modal-footer" style={{ display: 'flex', justifyContent: 'center' }}>
                <Button type="info" onClick={onCloseModal} style={{ marginRight: 20 }}>取消</Button>
                <Button type="primary" onClick={onConfirm}>确定</Button>
              </div>
            ) : ''
          }
        </div>
      </Modal>
    );
  }
}
